import { StyledText, Tooltip } from '@clickcease/cc-client-components-lib'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TagsContainer, TagsSelectionRow, TooltipContainer } from './Connector.styled'
import { ConnectionsList } from './ConnectionsList'

export const Connector = () => {
  const { t } = useTranslation('googleAnalytics')

  return (
    <TagsContainer>
      <TagsSelectionRow>
        <StyledText variant={'baseBold'}>{t('connector.domain')}</StyledText>
        <TooltipContainer>
          <StyledText variant={'baseBold'}>{t('connector.measurement-id')}</StyledText>
          <Tooltip
            tooltiptContent={t('connector.measurement-id-tooltip')}
            trigerStyle={{ width: '16px', height: '16px' }}
          />
        </TooltipContainer>
        <StyledText variant={'baseBold'}></StyledText>
      </TagsSelectionRow>
      <ConnectionsList />
    </TagsContainer>
  )
}
